"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Radio;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var icon_1 = __importStar(require("stories/icon"));
var flex_container_1 = __importDefault(require("web/components/primitives/flex-container"));
var styles_scss_1 = __importDefault(require("./styles.scss"));
function Radio(_a) {
    var _b, _c, _d;
    var _e = _a.value, value = _e === void 0 ? false : _e, onChange = _a.onChange, _f = _a.description, description = _f === void 0 ? '' : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.locked, locked = _h === void 0 ? false : _h, _j = _a.className, className = _j === void 0 ? '' : _j, name = _a.name, props = __rest(_a, ["value", "onChange", "description", "disabled", "locked", "className", "name"]);
    var hiddenInputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (hiddenInputRef.current) {
            hiddenInputRef.current.value = value;
        }
    }, [value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(flex_container_1.default, __assign({ alignItems: "center", className: (0, classnames_1.default)(className, styles_scss_1.default.wrapper, (_b = {},
                _b[styles_scss_1.default.selected] = value,
                _b[styles_scss_1.default.disabled] = disabled,
                _b[styles_scss_1.default.locked] = locked,
                _b)), onClick: function (e) {
                e.stopPropagation();
                if (disabled || locked) {
                    return;
                }
                onChange(!value);
            }, role: "button", tabIndex: 0, "aria-pressed": value, "data-qa-radio": value }, props),
            react_1.default.createElement(icon_1.default, { className: (0, classnames_1.default)(styles_scss_1.default.icon, (_c = {},
                    _c[styles_scss_1.default.disabled] = disabled,
                    _c[styles_scss_1.default.locked] = locked,
                    _c)), type: value || locked ? icon_1.IconType.checkCircle : icon_1.IconType.circle }),
            !!description && (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_scss_1.default.description, (_d = {},
                    _d[styles_scss_1.default.disabled] = disabled,
                    _d[styles_scss_1.default.locked] = locked,
                    _d)) }, description))),
        react_1.default.createElement("input", { type: "hidden", name: name, ref: hiddenInputRef })));
}
Radio.propTypes = {
    value: prop_types_1.default.bool,
    onChange: prop_types_1.default.func.isRequired,
    description: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    locked: prop_types_1.default.bool,
    name: prop_types_1.default.string.isRequired,
};
